import React, { Component } from "react";
import PropTypes from "prop-types";
import Button from "./Button";
import styles from "./UploadButton.module.css";

export default class UploadButton extends Component {
  render() {
    const { className } = this.props;
    const classOverride = className ? " " + className : "";

    return (
      <div className={styles.container + classOverride}>
        <Button {...this.props} />
        <input type="file" onChange={this.props.onChange} />
      </div>
    );
  }
}

UploadButton.propTypes = {
  onChange: PropTypes.func,
  className: PropTypes.string,
};
